import { AlertCircle } from '@untitledui/icons';

export function ZeroAudiencesError() {
  return (
    <div className='bg-utility-warning-50 p-4 rounded-lg border border-utility-warning-200'>
      <div className='flex items-start gap-3'>
        <AlertCircle className='w-5 h-5 text-utility-warning-600 mt-0.5 shrink-0' />
        <div className='flex-1'>
          <p className='text-sm font-semibold text-utility-warning-900'>
            No audiences found
          </p>
          <p className='text-sm text-utility-warning-700 mt-1'>
            Your Mailchimp account doesn&apos;t have any audiences yet.
            <a
              href='https://mailchimp.com/help/create-audience/'
              target='_blank'
              rel='noopener noreferrer'
              className='underline ml-1'
            >
              Create an audience in Mailchimp
            </a>
            , then come back and try again.
          </p>
        </div>
      </div>
    </div>
  );
}
